export default "__VITE_ASSET__MPr8mifB__"